import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFaceGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M39.72 25.714a3.515 3.515 0 0 0-2.917-3.456v-1.81C36.803 13.584 31.219 8 24.355 8c-6.864 0-12.438 5.584-12.438 12.448v1.81A3.515 3.515 0 0 0 9 25.713a3.515 3.515 0 0 0 2.917 3.456v.337c0 4.726 9.492 9.588 9.858 9.771.78.472 1.675.722 2.58.722s1.8-.25 2.541-.703c.405-.202 9.907-5.073 9.907-9.8v-.337a3.497 3.497 0 0 0 2.917-3.446Zm-4.12-5.266v1.713c-1.59-.183-3.158-1.059-4.458-2.522-1.82-2.05-2.86-4.939-2.6-7.201.058-.809.078-1.617.078-2.378a11.214 11.214 0 0 1 6.98 10.388ZM24.354 9.203c1.059 0 2.08.154 3.061.434 0 1.848-.048 4.024-.616 5.766-1.838 5.622-8.317 6.826-13.68 6.797v-1.762c0-6.19 5.045-11.235 11.235-11.235Zm-14.152 16.51c0-1.068.732-1.954 1.714-2.223v4.447a2.313 2.313 0 0 1-1.714-2.223ZM26.32 38.258a3.82 3.82 0 0 1-3.957-.019c-2.57-1.3-9.242-5.41-9.242-8.722v-6.103h.203c7.74 0 12.717-2.503 14.478-7.259a12.143 12.143 0 0 0 2.436 4.284c1.54 1.733 3.427 2.753 5.362 2.936v6.152c0 3.302-6.671 7.403-9.28 8.732Zm10.484-10.32V23.49a2.313 2.313 0 0 1 1.713 2.224 2.313 2.313 0 0 1-1.713 2.223Z",
    fill: "currentColor"
  }));
}

export { SvgFaceGlyph as default };
